export default {
    data: null,
    isFetching: false,
    isPosting: false,
};
